var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outline Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.948,29.987H7.71a2.931,2.931,0,0,1-2.929-2.928V10.283A2.931,2.931,0,0,1,7.71,7.355H18.948a2.931,2.931,0,0,1,2.928,2.928V27.059A2.931,2.931,0,0,1,18.948,29.987ZM7.71,9.686a.6.6,0,0,0-.6.6V27.059a.6.6,0,0,0,.6.6H18.948a.6.6,0,0,0,.6-.6V10.283a.6.6,0,0,0-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.437,24.645a1.166,1.166,0,1,1,0-2.331.451.451,0,0,0,.451-.451V4.8a.451.451,0,0,0-.451-.451H12.905a.451.451,0,0,0-.45.451,1.166,1.166,0,0,1-2.331,0,2.784,2.784,0,0,1,2.781-2.782H24.437A2.785,2.785,0,0,1,27.219,4.8V21.863A2.785,2.785,0,0,1,24.437,24.645Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.453981ed8ec8c86315b29e6322850d51.svg";
export { ForwardRef as ReactComponent };